var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumpsellerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "-12.5 -4 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4003 34.8058C16.4469 33.6392 20.4463 31.2901 27.9639 7.90509C28.4933 6.25908 28.5949 5.31622 27.6057 3.9632C27.2902 3.53705 27.0443 3.18015 26.8518 2.88717L25.9268 1.61404C25.7396 1.35835 24.8735 0.17046 24.0233 0.0213075C23.1732 -0.127845 21.9487 0.692494 21.6867 0.868281L7.4214 10.4833C6.34134 11.2131 6.18628 12.0814 6.12212 12.4489L2.73223 31.599C2.27775 34.1613 2.11734 35.0775 5.4003 34.8058Z",
    fill: "#9FCC2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0163 15.5065L33.5246 12.076C32.1077 10.185 31.1827 8.79467 30.5358 11.5167C26.932 26.6131 24.6489 33.7937 20.0774 37.9753C14.8482 42.7588 7.90797 43.9094 3.66793 44.57C0.625584 45.0387 0.320814 45.3104 0.208531 45.8484L0.0641665 46.6581C-0.197828 48.1337 0.320814 48.8688 1.80189 49.1298L28.0334 53.7375C29.5145 53.9985 30.2524 53.4818 30.5144 52.0063L30.6801 51.0741L36.5723 17.7971C36.6365 17.4295 36.7916 16.5666 36.0216 15.5065H36.0163Z",
    fill: "#9FCC2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpsellerIcon);
export default __webpack_public_path__ + "static/media/jumpsellerIcon.f5a5251474d9d7a1a6c3d55fc75a96f0.svg";
export { ForwardRef as ReactComponent };